import React from "react";
import SrinivasaMain from "../components/projects/srinivasa/Main";
import { getSEOData } from "../utils/seo";

function Srinivasa() {
  const seoData = getSEOData("srinivasa-west-mambalam-chennai");
  return (
    <SrinivasaMain seoData={seoData} />
  );
}

export default Srinivasa